export default "__VITE_ASSET__Dk8Pqxox__"